import React, { useState  ,useEffect} from 'react'
import portfolios from '../assets/data/portfolioData'
import { Alert } from 'bootstrap'
import axios from 'axios'
function Modal({activeId, setShowModal }) {
    const [portfolios, setPortfolios] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('https://por2.onrender.com/api/projects?populate=*');
                setPortfolios(response.data.data); // Set projects directly from response.data.data
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []); // Fetch data when the component mounts
    
    // Find the portfolio only if portfolios array is not empty
    const portfolio = portfolios.find(portfolio => portfolio.id === activeId);
    return (
<div className='w-full h-full fixed top-0 left-0 z-10 bg-gray-900 bg-opacity-60 flex items-center justify-center'>
    <div className=' md:max-w-[600px] bg-white rounded-[8px] p-5 flex flex-col items-end'>
        {portfolio && (
            <div className="flex flex-wrap items-center justify-center">
                <div className="relative" style={{ height: "400px" }}>
                <figure className="h-full">
                    <img className='rounded-[8px] h-full w-full object-cover' src={portfolio.attributes.image.data.attributes.url} alt="" />
                </figure>
                </div>
                <div className="w-full pl-4">
                    <h2 className='text-xl md:text-2xl text-sky-500 md:font-[600] md:my-4'>{portfolio.attributes.title}</h2>
                    <p className=' md:text-lg text-gray-800 font-[300] '>{portfolio.attributes.description}</p>
                    {portfolio.attributes.technologies && portfolio.attributes.technologies.length > 0 && (
                        <div className=' mt-2 md:mt-5 flex item-center gap-3 flex-wrap'>
                            <h4 className='text-sky-500 md:text-[18px] text-[700]'>Technologies:</h4>
                            {portfolio.attributes.technologies.split(',').map((item, index) => (
                                <span key={index} className='bg-gray-200 py-1 px-2 rounded-[5px] md:text-[14px] leading-0 '>
                                    {item.trim()}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
                <a href={portfolio.attributes.Lien}>
                    <button className='text-white bg-sky-500 rounded-lg py-2 px-4  mt-4 md:mt-6 ease-in duration-800 hover:text-blod hover:bg-slate-500 hover:text-sky-950'>Live Project</button>
                </a>
            </div>
        )}
            <button onClick={() => setShowModal(false)} class="w-[2.5rem] bg-sky-500  rounded-md p-2 absolute  text-white hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
    </button>   
    </div>
</div>


    );
}

export default Modal;
